import Cookies from 'js-cookie';

export type GCLIDParameters = {
  gclidTracker: string;
};

/** Read GCLID tracker from cookies */
export const getGCLIDParameters = (): GCLIDParameters | undefined => {
  const gclidCookie = Cookies.get('gclid');

  if (gclidCookie) {
    return {
      gclidTracker: gclidCookie,
    };
  }
  return undefined;
};
